import _ from 'lodash';

export const getFieldWarnings = warnings => {
  if (!warnings) return {};

  let result = {};

  warnings
    .filter(warning => !_.isNil(warning.field) && warning.field !== '__all__')
    .forEach(warning => {
      _.set(result, warning.field, warning.message);
    });

  return result;
};

export const getNonFieldWarnings = warnings =>
  warnings &&
  warnings
    .filter(warning => _.isNil(warning.field) || warning.field === '__all__')
    .map(warning => warning.message);

export const getWarnings = warnings => {
  let formWarnings: any = {
    ...getFieldWarnings(warnings)
  };

  const nonFieldWarnings = getNonFieldWarnings(warnings);
  if (!_.isEmpty(nonFieldWarnings)) {
    formWarnings._warning = nonFieldWarnings;
  }

  return formWarnings;
};
